import { Component } from '@angular/core';
import { SharedFunctionService } from '../../services/shared-func.service';

@Component({
  selector: 'unauthorized',
  templateUrl: 'unauthorized.component.html',
  styleUrls: ['unauthorized.component.scss'],
})
export class UnauthorizedComponent {

  constructor(private readonly _sharedFuncService : SharedFunctionService ) {}

  public logout() {
    this._sharedFuncService.logout(window);
  }

}
